import { render, staticRenderFns } from "./MerkatoInitialize.vue?vue&type=template&id=44580b25&"
import script from "./MerkatoInitialize.vue?vue&type=script&lang=js&"
export * from "./MerkatoInitialize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports